import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { HomeScreen, AccessGateScreen, SafetyScreen, HardStopScreen, PainLocationScreen, CPGQuestionScreen, SubtypeQuestioningScreen, SelfAssessmentScreen, PreNprScreen, TestIntroScreen, HowChallengingScreen, FeelAffectScreen, TestIntroTwo, Feedback2, PlanRecommendation, RecoveryScoreScreen, ScreenPlan, InvalidCodeScreen, FloorCapabilityScreen, IntroAR, ProblemAreaScreen, SafetyScreeningScreen, PdfViewerPage } from "./SelfAssesment";
import { LandingPage } from "../virdioHealth/LandingPage";
import { AboutUs } from "../virdioHealth/About";
import { ContactUs } from "../virdioHealth/ContactUs";
const isVirdioDomain = ["virdiohealth.com", "www.virdiohealth.com"].includes(window.location.host);


const useDisableBackButton = () => {
  useEffect(() => {
    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
      }
    };

    // Wipe any history entry behind and lock this one
    window.history.pushState(null, "", window.location.href);

    // Listen for any back/forward attempts
    window.addEventListener("popstate", blockBack);
    return () => {
      window.removeEventListener("popstate", blockBack);
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
      }
    };
  }, []);
};

export default function AppRoutes() {
  const searchParams = new URLSearchParams(window.location.search);
  const hasAfter = searchParams.has("after") && localStorage.getItem("runStep") !== "2" ? true : false;
  const hasSecondTest = searchParams.has("after") && localStorage.getItem("runStep") === "2" ? true : false;
  if (hasAfter) {
    window.initFromUserGesture();
  }
  useDisableBackButton();
  return (
    <Router>
      <Switch>
        <Route path="/" exact render={() => (hasAfter ? <HowChallengingScreen /> : hasSecondTest ? <Feedback2 /> : isVirdioDomain ? <LandingPage /> : <HomeScreen />)} />
        <Route path="/index.html" render={() => (hasAfter ? <HowChallengingScreen /> : hasSecondTest ? <Feedback2 /> : isVirdioDomain ? <LandingPage /> : <HomeScreen />)} />
        {/* the rest stay the same */}

        <Route path="/virdiohealth" component={LandingPage} />
        <Route path={`/about`} component={AboutUs} />
        <Route path={`/contact-us`} component={ContactUs} />
        <Route path="/access-gate" component={AccessGateScreen} />
        <Route path="/red-flags" component={SafetyScreen} />
        <Route path="/invalid-code" component={InvalidCodeScreen} />
        <Route path="/hard-stop" component={HardStopScreen} />
        <Route path="/problem-area" component={ProblemAreaScreen} />
        <Route path="/pain-location" component={PainLocationScreen} />
        <Route path="/safety-screening" component={SafetyScreeningScreen} />
        <Route path="/cpg-questions" component={CPGQuestionScreen} />
        <Route path="/subtype-questioning" component={SubtypeQuestioningScreen} />
        <Route path="/self-assesment" component={SelfAssessmentScreen} />
        <Route path="/pre-npr" component={PreNprScreen} />
        <Route path="/floor-capability" component={FloorCapabilityScreen} />
        <Route path="/intro-ar" component={IntroAR} />
        <Route path="/test-intro" component={TestIntroScreen} />
        <Route path="/how-challenging" component={HowChallengingScreen} />
        <Route path="/feel-affect" component={FeelAffectScreen} />
        <Route path="/test-intro-2" component={TestIntroTwo} />
        <Route path="/feedback-2" component={Feedback2} />
        <Route path="/plan-recommendation" component={PlanRecommendation} />
        <Route path="/recovery-score" component={RecoveryScoreScreen} />
        <Route path="/screen-plan" component={ScreenPlan} />
        <Route path="/pdf-viewer" component={PdfViewerPage} />
      </Switch>
    </Router>
  );
}
